var store = {};

exports.registerMixin = function (name, mixin) {
  store[name] = mixin;
};

exports.mixins = store;